import { useEffect, useMemo, useState } from 'react'
import { useWireValue } from '@forminator/react-wire'
import * as store from '@store'
import * as actions from '@actions'
import { useFormik } from 'formik'
import { useParams } from 'react-router-dom'
import { formatDate } from '@/utils/date'
import { useAccessUser } from '@/hook/useAccessUser'
import { useDisabledHover } from '@/hook/useDisabledHover'
import SettingsWrapper from './SettingsWrapper'
import { toast } from 'react-toastify'

// 2023-03-30
// Did some cleanup, & added credits balance, but this needs a revamp
export const PersonalInfo = () => {
    
    const { email } = useParams()
    
    const user = useWireValue(store.user)
    const credits = useWireValue(store.credits)
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmNewPassword, setConfirmNewPassword] = useState('')
    
    // @todo no idea what this is
    // const editUser = useMemo(() => users.filter(user => user.email === email)[0] || {}, [email, users])
    const editUser = useMemo(() => JSON.parse(JSON.stringify(user ?? {})), [user])
    
    const totalBalance = useMemo(() => (
        (credits.user || 0) + (credits.organization || 0)
    ), [credits])
    
    const firstName = useAccessUser({
        accessType: 'admin_controls',
        accessName: 'first_name',
    })
    const lastName = useAccessUser({
        accessType: 'admin_controls',
        accessName: 'last_name',
    })
    const resetPassword = useAccessUser({
        accessType: 'admin_controls',
        accessName: 'reset_password',
    })
    
    const firstNameHover = useDisabledHover(!firstName)
    const lastNameHover = useDisabledHover(!lastName)
    
    // @todo why is this fetching all users
    useEffect(() => {
        actions.fetchUsers()
    }, [])
    
    const formik = useFormik({
        enableReinitialize: true,
        
        initialValues: {
            id: editUser.id,
            
            // username: editUser.user_name || '',
            firstName: editUser.firstName || '',
            lastName: editUser.lastName || '',
            email: editUser.email || '',
            company: editUser.company || '',
            phone: editUser.phone || '',
            isVerified: editUser.isVerified || undefined,
            isAdmin: editUser.isAdmin || undefined,
            
            // isManager: editUser.isManager || undefined,
            lastLogin: editUser.lastLogin || undefined,
            lastActivity: editUser.lastActivity || undefined,
        },
        
        onSubmit: values => {
            if (user.email && user.id) {
                actions.updateUser(email, values, '', '')
                toast.success('Changes are successfully saved.')
            }
        },
    })
    
    const { handleSubmit, handleChange, values } = formik
    
    const changeCurrentPassword = async values => {
        const passwordRegex = new RegExp('^(((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})')
        
        if (!values.currentPassword || !values.newPassword || !values.confirmNewPassword) {
            
            toast.error('Please fill in all the fields.')
            
        } else if (values.newPassword !== values.confirmNewPassword) {
            
            toast.error('Password and confirm password does not match.')
            
        } else if (!passwordRegex.test(values.newPassword)) {
            
            toast.error('Password does not meet the requirements.')
            
        } else {
            const res = await actions.resetUserPassword(user.id, values.currentPassword,
                values.newPassword, values.confirmNewPassword)
            
            if (res) {
                toast.success('Password has been changed successfully.')
            } else {
                toast.error('Failed to change password. Try Again.')
            }
        }
    }
    
    const newValues = {
        currentPassword: currentPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmNewPassword,
    }
    
    return (
        <SettingsWrapper title="Personal Info" buttonLabel="Save" onClick={() => handleSubmit()}>
            <>
                
                <div>
                    
                    <div className="flex gap-10 split-form-balances">
                        
                        <form onSubmit={handleSubmit}>
                            
                            <div className="flex flex-col gap-4">
                                
                                <section className="flex gap-4">
                                    <div className="form-group">
                                        <label className="col-form-label">First Name</label>
                                        <div className="" {...firstNameHover}>
                                            <input
                                                type="text"
                                                className="input input-bordered"
                                                name="firstName"
                                                placeholder="e.g. John"
                                                value={values.firstName}
                                                onChange={handleChange}
                                                disabled={!firstName} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-form-label">Last Name</label>
                                        <div className="" {...lastNameHover}>
                                            <input
                                                type="text"
                                                className="input input-bordered"
                                                name="lastName"
                                                placeholder="e.g. Doe"
                                                value={values.lastName}
                                                onChange={handleChange}
                                                disabled={!lastName} />
                                        </div>
                                    </div>
                                </section>
                                
                                <section className="flex gap-4">
                                    <div className="form-group">
                                        <label className="col-form-label">Email</label>
                                        <div>
                                            <input
                                                type="text"
                                                className="input input-bordered"
                                                name="email"
                                                placeholder="example@mail.com"
                                                value={values.email}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-form-label">Phone</label>
                                        <div>
                                            <input
                                                type="text"
                                                className="input input-bordered"
                                                name="phone"
                                                placeholder="Phone number"
                                                value={values.phone}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                </section>
                                <section className="flex flex-col gap-4">
                                    <div className="flex gap-4 justify-start items-end">
                                        <div className="flex flex-col">
                                            <label className="col-form-label">Current Password</label>
                                            <input
                                                type="password"
                                                name="currentPassword"
                                                id="currentPassword"
                                                className="input input-bordered"
                                                onChange={event => {
                                                    setCurrentPassword(event.target.value)
                                                }}
                                                placeholder="Current password" />
                                        </div>
                                        <div className="flex flex-col">
                                            <label className="col-form-label">New Password</label>
                                            <input
                                                type="password"
                                                name="newPassword"
                                                id="newPassword"
                                                className="input input-bordered"
                                                onChange={event => {
                                                    setNewPassword(event.target.value)
                                                }}
                                                placeholder="New password" />
                                        </div>
                                        <div className="flex flex-col">
                                            <label className="col-form-label">Confirm New Password</label>
                                            <input
                                                type="password"
                                                name="confirmNewPassword"
                                                id="confirmNewPassword"
                                                className="input input-bordered"
                                                onChange={event => {
                                                    setConfirmNewPassword(event.target.value)
                                                }}
                                                placeholder="Confirm new password" />
                                        </div>
                                        <button
                                            onClick={() => changeCurrentPassword(newValues)}
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={!resetPassword}>
                                            Reset Password
                                        </button>
                                    </div>
                                    <div className="mb-2 text-slate-400 text-sm">
                                        <small>
                                            Use 8 or more characters with a mix of letters, numbers & symbols.
                                        </small>
                                    </div>
                                </section>
                            
                            </div>
                        
                        </form>
                        
                        <div
                            className="flex flex-col w-1/3 pt-2 pl-5 border-l border-gray-700 balances"
                            style={{ display: 'none' }}>
                            
                            <div className="flex flex-col gap-2 your-balance">
                                <h4 className="mt-1 font-bold">Your Balance</h4>
                                <div className="font-mono">
                                    ${(credits?.user ?? 0).toFixed(2)}
                                </div>
                            </div>
                            
                            <div className="flex flex-col gap-2 mt-4 org-balances">
                                <h4 className="mt-1 font-bold">Organization Balance(s)</h4>
                                {user?.organizations?.map(it => (
                                    <div key={it.id} className="font-mono">
                                        {it.name}: ${(it.credits ?? 0).toFixed(2)}
                                    </div>
                                ))}
                            </div>
                            
                            <div className="mt-4 total-balance">
                                <h4 className="mt-1 font-bold">Total Balance</h4>
                                <div className="font-mono">
                                    ${totalBalance.toFixed(2)}
                                </div>
                            </div>
                        
                        </div>
                    
                    </div>
                    
                    <div>
                        
                        <div className="text-slate-400 text-xs">
                            Last Login:
                            {' '}
                            {formatDate(new Date())}
                        </div>
                    
                    </div>
                
                </div>
            
            </>
        </SettingsWrapper>
        
        
    )
}
